import * as React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';

export default function BankSkeleton() {
  return (
    <div className='flex flex-wrap gap-6 mt-5'>
      {[1, 2, 3].map((item) => (
        <Box key={item} sx={{ width: 335, height: 148 }}>
          <Skeleton 
            variant="rectangular" 
            width={335} 
            height={148} 
            sx={{ borderRadius: '16px', backgroundColor: 'rgba(0, 0, 0, 0.05)' }} 
          />
        </Box>
      ))}
    </div>
  );
}
